<template>
    <div class="top_sub_slider_wrapper">
        <div class="top_sub_slider">
            <img src="/src/assets/img/common/slider-arrow-prev.png" loading="lazy" alt="＜" class="slide-arrow prev-arrow" aria-disabled="false">
            <div class="swiper-wrapper">

                <div class="swiper-slide" v-for="(banner, index) in banner_list" :key=index>
                    <a :href="banner.LINK_URL" class="top-img-box" :id="'GTMtopLink_thumbnail_'+ (index + 1)" :alt="banner.ALT_TXT">
                        <div class="c-slider-small__img">
                            <img :src="banner.banner_file_path" :alt="banner.ALT_TXT" loading="lazy" />
                        </div>
                    </a>
                </div>

            </div>
            <img src="/src/assets/img/common/slider-arrow-next.png" loading="lazy" alt="＞" class="slide-arrow next-arrow" />
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper/bundle';
export default {
  props: [
    'banner_list',
  ],
  data () {
    return {
    }
  },
  mounted: function() {
    const swiper = new Swiper('.top_sub_slider', {
        freeMode: {
            enabled: true,
            momentumBounce: true,
        },
        slidesPerView: 3.5,
        spaceBetween: 4,
        navigation: {
            nextEl: ".next-arrow",
            prevEl: ".prev-arrow"
        },
        spaceBetween: 0,
        breakpoints: {
            575: {
                slidesPerView: 5,
                spaceBetween: 6,
            }
        },
        centerInsufficientSlides: true,
    });
  },
}
</script>
<style lang="scss" scoped>
.top_sub_slider_wrapper {
    @media screen and (max-width: 575px) {
        margin: 0 15px 30px;
    }
}
.top_sub_slider {
    width: 75%;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
    position: relative;

    @media screen and (max-width: 575px) {
        width: 100%;
        margin-bottom: 30px;
    }
}
</style>
